import PageWrapper from "./src/components/PageWrapper"
export const wrapPageElement = PageWrapper